import { RichContentComponent } from "@affinity/Overrides/Widgets/Basic/RichContent";
import React from 'react'

interface OwnProps {
    content: string;
}

const CancelOrderInfo = ({ content }: OwnProps) => {
    return (
        <RichContentComponent fields={{
            padding: false,
            content
        }} css={undefined} />
    )
}

export default CancelOrderInfo